import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
`;

export const TableSearchTracks = styled.form`
  display: flex;
  gap: 1rem;
  align-items: end;
`; 